export default __webpack_public_path__ + "static/media/notification_announcement_icon.4bb7226b.svg";